/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Describes the execution status of an order
 */
export enum EnumProcessState {
    /**
     * The process was just created
     */
    Open = 0,
    /**
     * Execution of the process is currently ongoing
     */
    InProgress = 1,
    /**
     * All required actions that are required for the process have been performed
     */
    ExecutionFinished = 2,
    /**
     * All the data in the process was checked and approved for completion
     */
    Approved = 3,
    /**
     * The process is complete. No further changes can be made.
     */
    Completed = 4,
}
